/**
 * Payroll Setup Page & Table Style Definitions (MUI sx objects)
 * Path: src/styles/payrollSetup.styles.js
 */

export const payrollSetupStyles = {
    // --- PayrollSetup Page Container & Header ---
    uploadIcon: {
        color: "secondary.main",
        fontSize: 32,
        mt: 0.5,
        cursor: "pointer"
    },
    addNewButton: {
        px: 3,
        fontSize: "12px",
        borderRadius: 1
    },
    tableWrapperStack: {
        border: "1px solid #e0e0e0",
        borderRadius: 1,
        overflow: "hidden"
    },
    tableWrapperBox: {
        flexGrow: 1,
        overflow: "hidden"
    },
    paginationFooter: {
        height: "30px",
        background: "linear-gradient(to bottom, #e6e6e6 0%, #f2f2f2 50%, #e6e6e6 100%)",
        borderTop: "1px solid #cfcfcf",
        borderBottom: "1px solid #cfcfcf"
    },

    // --- SetupTable Component ---
    tableContainer: {
        height: "100%",
        p: 0,
        overflowX: "auto",
        overflowY: "hidden",
        "&::-webkit-scrollbar": { width: 5, height: 5 },
        "&::-webkit-scrollbar-thumb": { backgroundColor: "#bdbdbd", borderRadius: 10 }
    },
    bodyScroll: {
        flex: 1,
        overflowY: "auto",
        overflowX: "hidden",
        "&::-webkit-scrollbar": { width: 5 },
        "&::-webkit-scrollbar-thumb": { backgroundColor: "#bdbdbd", borderRadius: 10 }
    },
    headerFilterCell: {
        padding: "0px 5px",
        height: "35px",
        backgroundColor: "#ffffff",
        borderTop: "1px solid #f2f2f2",
        borderBottom: "1px solid #f2f2f2",
        borderLeft: "1px solid #f2f2f2",
        borderRight: "1px solid #f2f2f2"
    },
    bodyCellBase: {
        borderBottom: "1px solid #f2f2f2",
        borderRight: "1px solid #f2f2f2",
        fontSize: "0.75rem",
        fontWeight: 500,
        color: "#626262",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    },
    headerCellBase: {
        background: "linear-gradient(to bottom, #e6e6e6 0%, #f2f2f2 50%, #e6e6e6 100%)",
        borderTop: "1px solid #f2f2f2",
        borderBottom: "1px solid #f2f2f2",
        borderRight: "1px solid #f2f2f2",
        fontSize: "0.8rem",
        fontWeight: 500,
        color: "#000",
        padding: "5px",
        whiteSpace: "nowrap"
    },
    actionButtonsStack: {
        width: "100%"
    },
    actionIconButton: {
        padding: "4px"
    },
    actionsSizerBox: {
        position: "absolute",
        visibility: "hidden",
        pointerEvents: "none",
        px: "5px",
        display: "inline-flex"
    },
    filterTextField: {
        "& .MuiOutlinedInput-root": {
            backgroundColor: "white",
            fontSize: "0.75rem",
            "& input": {
                padding: "0px 5px",
                height: "25px",
                boxSizing: "border-box",
                "&::placeholder": {
                    color: "#444",
                    opacity: 1
                }
            }
        }
    },
    filterIconButton: {
        padding: "8px 8px"
    },
    filterIcon: {
        fontSize: 18,
        color: "#1976D2"
    },
    tableRowHover: {
        "&:hover": {
            backgroundColor: "#f8f9fa"
        }
    },
    emptyStateCell: {
        fontSize: 14,
        color: "#999",
        py: 3
    },
    filterMenuPaper: {
        maxHeight: 300,
        width: "150px"
    },
    filterMenuItem: {
        fontSize: "0.75rem",
        "&.Mui-selected": {
            backgroundColor: "#275D97",
            color: "white",
            "&:hover": { backgroundColor: "#275D97" }
        }
    },

    // --- Import Modal Shared Styles ---
    importDialog: {
        "& .MuiDialog-container": {
            alignItems: "flex-start"
        },
        "& .MuiDialog-paper": {
            height: "85vh",
            maxHeight: "90vh",
            mt: 4,
            display: "flex",
            flexDirection: "column",
        }
    },
    importToolbar: {
        backgroundColor: "#F8F9FA",
        minHeight: '37px !important',
        gap: 1
    },
    importTitle: {
        flex: 1,
        color: "#2782EC"
    },
    exportErrorsBtn: {
        fontSize: "11px",
        px: 2,
        textTransform: "none"
    },
    importSubmitBtn: {
        fontSize: "11px",
        px: 2,
        backgroundColor: "white",
        color: "green",
        border: "1px solid green",
        textTransform: "none",
        "&:hover": { backgroundColor: "green", color: "white" }
    },
    importCloseIcon: {
        color: "white",
        fontSize: "11px"
    },
    importDialogContent: {
        padding: 2
    },
    importTableContainer: {
        border: "1px solid #e0e0e0",
        borderRadius: 1
    },
    importTableRowHeader: {
        '& .MuiTableCell-root': {
            backgroundColor: '#f5f5f5',
            fontWeight: 'bold',
            whiteSpace: 'nowrap'
        }
    },

    // --- Add New / Edit Payroll Modal ---
    backdrop: {
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1
    },
    addNewDialogContent: {
        p: 2,
        height: "100%"
    },

    // --- COA Configurations Component ---
    coaTableContainer: {
        height: "100%",
        border: "1px solid #e8e8e8",
        overflow: "auto"
    },
    coaTableHead: {
        "& .MuiTableCell-head": {
            backgroundColor: "#E5E7EC",
            fontSize: 13,
            color: "#2782EC",
            fontWeight: 500
        }
    },
    coaAddRowBtn: {
        whiteSpace: "nowrap",
        background: "#B5DCF2",
        fontSize: 12,
        padding: "2px 10px"
    },
    coaOptionLabel: {
        flex: 1,
        minWidth: 0,
        whiteSpace: "nowrap"
    },
    getCoaOptionTypeSx: (selected) => ({
        whiteSpace: "nowrap",
        flexShrink: 0,
        fontWeight: 600,
        color: selected ? "white" : "#6d6d6d"
    }),
    coaDropdownMinWidth: {
        minWidth: 170
    },
    coaPopperSx: {
        width: "400px !important",
        maxWidth: "calc(100vw - 24px)"
    },
    coaDeleteRowBtn: {
        width: 24,
        height: 24,
        border: "1.75px solid #e54855",
        color: "#d32f2f",
        borderRadius: "50%",
        padding: 0,
        "&:hover": {
            borderColor: "#d32f2f"
        }
    },
    coaDeleteRowCloseIcon: {
        fontSize: 14
    },
    getCoaDropdownSx: (isDisabled) => ({
        minWidth: 170,
        "& .MuiFilledInput-root": {
            backgroundColor: isDisabled ? "#E0E0E0 !important" : "white",
            "&:hover": { backgroundColor: isDisabled ? "#E0E0E0 !important" : "white" },
            "&.Mui-focused": { backgroundColor: isDisabled ? "#E0E0E0 !important" : "white" },
            "&.Mui-disabled": {
                backgroundColor: "#E0E0E0 !important",
                WebkitTextFillColor: "#000 !important",
                color: "#000 !important"
            }
        },
        "& .MuiFilledInput-input": {
            paddingTop: "6px",
            paddingBottom: "6px",
            "&.Mui-disabled": {
                WebkitTextFillColor: "#000 !important",
                color: "#000 !important"
            }
        }
    }),

    // --- Payroll Basic Info Section ---
    basicInfoTextField: {
        "& .MuiFilledInput-root": {
            height: 32,
            backgroundColor: "white",
            "&:hover": { backgroundColor: "white" },
            "&.Mui-focused": { backgroundColor: "white" },
            "&.Mui-disabled": {
                backgroundColor: "#E0E0E0 !important",
                WebkitTextFillColor: "#000 !important",
                color: "#000 !important"
            }
        },
        "& .MuiFilledInput-input": {
            padding: "6px 12px",
            fontSize: 11,
            "&.Mui-disabled": {
                WebkitTextFillColor: "#000 !important",
                color: "#000 !important"
            }
        }
    },
    getBasicInfoDropdownSx: (isDisabled) => ({
        "& .MuiFilledInput-root": {
            maxHeight: 32,
            backgroundColor: isDisabled ? "#E0E0E0 !important" : "white",
            "&:hover": { backgroundColor: isDisabled ? "#E0E0E0 !important" : "white" },
            "&.Mui-focused": { backgroundColor: isDisabled ? "#E0E0E0 !important" : "white" },
            "&.Mui-disabled": {
                backgroundColor: "#E0E0E0 !important",
                WebkitTextFillColor: "#000 !important",
                color: "#000 !important"
            }
        },
        "& .MuiFilledInput-input": {
            paddingTop: "6px",
            paddingBottom: "6px",
            "&.Mui-disabled": {
                WebkitTextFillColor: "#000 !important",
                color: "#000 !important"
            }
        }
    }),

    // --- Payroll Status Section ---
    cloneCheckboxLabel: {
        "& .MuiFormControlLabel-label": { fontSize: 11 }
    },
    cloneCountText: {
        mt: -0.5,
        ml: 3.5,
        cursor: "pointer",
        color: "primary.main",
        textDecoration: "underline",
        whiteSpace: "nowrap"
    },
    activeCheckboxLabel: {
        "& .MuiFormControlLabel-label": { fontSize: 12 }
    },
    updateCoaLabel: {
        mr: 1,
        "& .MuiFormControlLabel-label": { fontSize: 12 }
    }
};

export default payrollSetupStyles;
